export type SectionImage = {
  src: string
  alt: string
  caption: string
}

export const sectionImages: Record<
  | 'rollercoaster'
  | 'calories'
  | 'sequencing'
  | 'fiberShield'
  | 'example'
  | 'after30'
  | 'notThis'
  | 'method',
  SectionImage
> = {
  rollercoaster: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ab8f5f54-8dc6-4580-8e44-7f4de2c3f2b5.jpg',
    alt: 'Gráfico que compara una curva de glucosa con picos pronunciados frente a una curva estable',
    caption:
      'Representación simplificada de las subidas y bajadas de glucosa durante el día frente a una curva más estable. Gráfico ilustrativo.',
  },
  calories: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c43bf3b7-ddf2-4b5e-9a34-d86acf185ce0.jpg',
    alt: 'Dos platos con calorías similares: uno con pan y arroz blanco, otro con proteína, vegetales y grasas saludables',
    caption:
      'Dos comidas con calorías parecidas pueden sentirse muy diferentes según su estructura. Foto ilustrativa.',
  },
  sequencing: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/57605216-f50b-4a8d-9d03-401f22222507.jpg',
    alt: 'Tres tazones ordenados: vegetales, proteína con grasas saludables y arroz',
    caption:
      'El orden 1-2-3: primero fibra, luego proteína y grasas saludables, al final los carbohidratos. Foto ilustrativa.',
  },
  fiberShield: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/7afe65c2-3b38-403b-8735-28f39e1bdfa6.jpg',
    alt: 'Manos con un tenedor sobre un tazón de ensalada verde, con pan al fondo de la mesa',
    caption:
      'Empezar por los vegetales es lo que algunas personas llaman, de forma sencilla, un «escudo de fibra». Foto ilustrativa.',
  },
  example: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/d54682ff-031b-4434-b945-11208c7261f9.jpg',
    alt: 'Plato casero con arroz, pollo a la plancha y ensalada, junto a un vaso de agua',
    caption:
      'El mismo plato de siempre, comido en un orden distinto. Foto ilustrativa.',
  },
  after30: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/8213509f-c7bb-40d5-970a-ad4b5418e22a.jpg',
    alt: 'Mujer de casi 40 años en su escritorio, cansada y con poca concentración por la tarde',
    caption:
      'Después de los 30, el estrés, el descanso y el ciclo hormonal pueden influir en cómo se siente cada comida. Foto ilustrativa.',
  },
  notThis: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ac810cfa-a284-4938-b26c-ac6642e9da23.jpg',
    alt: 'Libreta abierta, lentes de lectura, una taza de té y un tazón de vegetales sobre una superficie clara',
    caption:
      'Es una herramienta educativa de alimentación consciente, no un tratamiento médico. Foto ilustrativa.',
  },
  method: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/d0f6b783-c27b-4067-b790-2917177a8753.jpg',
    alt: 'Planificador semanal de comidas en papel con un lápiz, un calendario y un tazón de vegetales',
    caption:
      'La propuesta no es comer perfecto, sino tener un mapa claro para 21 días. Foto ilustrativa.',
  },
}
